import { generateEventsDefinition } from '@guiker/event'

import { RentalOwner } from '../../entity'
import { baseEvent } from '../base'

const baseRentalOwnerEvent = {
  ...baseEvent,
  entity: 'RENTAL_OWNER',
  data: null as RentalOwner,
}

export const { RentalOwnerEventsDefinition } = generateEventsDefinition({
  ...baseRentalOwnerEvent,
})

export const Events = RentalOwnerEventsDefinition.events
export const EventTypes = RentalOwnerEventsDefinition.eventTypes
export type RentalOwnerEventTypes = typeof EventTypes
